let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6MyoK")).then(() => parcelRequire('4PKSS'));